import Vue from "vue";
import Component from "vue-class-component";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "NewsletterToast" })
export default class NewsletterToast extends Vue {
    public localizer: any = Localizer;
    public isVisible: boolean = false;
    public isReady: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        let cookie = CookieHelper.getCookie("nwsl");
        let vm = this;
        if (!cookie && CookieHelper.isCookiePolicy()) {
            this.isVisible = true;

            setTimeout(() => {
                vm.isReady = true;
            }, 1000);
        }
    }

    public close() {
        CookieHelper.setCookie("nwsl", "nwsl", 30);
        this.isVisible = false;
    }

    public openNewsletterSubscribe() {
        let vm = this;
        CookieHelper.setCookie("nwsl", "nwsl", 365);
        this.isReady = false;

        setTimeout(() => {
            vm.isVisible = true;
        }, 300);

        this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
    }
}